export default 
{
	"progressbar-page-title": "Side",
	"name-suffix": "Suffiks",
	"fileupload-desc-progress-message": "Opplasting {progress}",
	"required-if-greater-than-or-equal": "{property} er nødvendig når {compareSource} er større enn eller lik {compareValue}.",
	"powered-by-cognito": "Drevet av Cognito Forms.",
	"form-name-default": "Uten navn",
	"field-choice-defaults": "Første Valg|Andre Valg|Tredje Valg",
	"additional-fee-default-label": "Tilleggsavgift",
	"authenticated-save-and-resume-email-dialog": "Send en lenke på e-post og gå tilbake til skjemaet for å fullføre innsendingen.",
	"string-length-between": "{property} må være mellom {min} og {max} tegn.",
	"update-button-text": "Oppdater",
	"address-zip-code-invalid": "Zip Code må formatert som #####-####.",
	"required-if-greater-than": "{property} er nødvendig når {compareSource} er større enn {compareValue}.",
	"compare-before": "{property} må være før {compareSource}.",
	"compare-after": "{property} må være etter {compareSource}.",
	"unsupported-browser-message": "Oh No! Du bruker en ustøttet nettleseren. {a}Klikk her {/a} for å oppgradere.",
	"shared-entry-email-subject": "Delt Koblingen",
	"send-button-text": "Sende",
	"venmo-help-text": "Koble til Venmo for å fortsette å betale.",
	"field-repeatingsection-item-label": "Element",
	"save-and-resume-email-not-sent-message": "Det var et problem.",
	"credit-card-cvv": "CVV",
	"range-at-least": "{property} må være minst {min}.",
	"entry-notification-full-entry-detail-link": "Se hele oppføring på cognitoforms.com.",
	"element-label-website": "Nettsted",
	"element-label-signature": "Signatur",
	"paypal-help-text": "Koble til PayPal for å fortsette å betale.",
	"card-on-file-agreement-validation": "Du må godta å lagre kortet ditt for fremtidige transaksjoner.",
	"marketing-button-4": "Bygg Din Egen Gratis",
	"field-datepicker-now": "Nå",
	"save-and-resume-email-resume-button": "Fortsett nå",
	"field-datepicker-next-month": "Neste måned",
	"quantity-remaining-text": "gjenstående",
	"payment-declined": "Betalingen avvist",
	"required-if-before": "{property} er nødvendig når {compareSource} er før {compareValue}.",
	"this-comma-that": "{0}, {1}",
	"compare-less-than": "{property} må være mindre enn {compareSource}.",
	"entry-admin-link": "",
	"required-many": "{0} er nødvendig.",
	"save-and-resume-multiple-days-expiration-email-message": "Kopiere eller e-post linken nedenfor og gå tilbake til skjemaet i løpet av de neste {days} dager å fullføre ditt bidrag.",
	"string-length-at-least": "{property} må være minst {min} tegn.",
	"credit-card-number": "Kredittkortnummer",
	"range-on-or-before": "{property} må være på eller før {max}.",
	"required-one": "{0} er nødvendig.",
	"fileupload-max-file-count-exceeded-message": "Bare {maxFileCount} filer kan lastes opp.",
	"order-transaction-details-header": "Transaksjonsdetaljer",
	"field-spinner-increase": "Øke",
	"payment-processing-fees": "Behandlingsgebyr",
	"payment": "Betaling",
	"field-choice-other-fill-in": "Annet",
	"shared-entry-email-message": "En oppføring har blitt delt med deg.",
	"shared-entry-workflow-link": "Se skjemaet.",
	"required-if-exists": "{property} er nødvendig når {compareSource} er spesifisert.",
	"concurrent-conflict-toast-message": "Kunne ikke sende inn fordi skjemainformasjonen er endret. Vennligst sjekk og prøv igjen.",
	"secured-by-paypal": "Sikret av ",
	"range-on-or-after": "{property} må være på eller etter {min}.",
	"payment-amount-due": "Totalbeløp",
	"required-name-first-and-last": "Fornavn og Etternavn er nødvendig.",
	"required": "{property} er nødvendig.",
	"string-format-alphabetic": "{property} kan bare inneholde bokstaver.",
	"quantity-limit": "{property} mengde overskredet.",
	"field-spinner-decrease": "Avta",
	"field-repeatingsection-add-link-text": "Legg til",
	"fileupload-max-size-exceeded-message": "Bare filer som er mindre enn {maxSize} MB kan lastes opp.",
	"credit-card-expiration": "MM/YY",
	"field-signature-notcaptured": "Ikke Fanges",
	"field-ratingscale-satisfied-unsatisfied-label": "Fornøyd/Misfornøyd",
	"range-between": "{property} må være mellom {min} og {max}.",
	"field-ratingscale-agree-disagree-label": "Enig/Uenig",
	"back-button-text": "Tilbake",
	"address-country": "Land",
	"order-not-found": "Fant ingen ordreinformasjon.",
	"field-ratingscale-satisfied-unsatisfied-options": "Svært Misfornøyd|Misfornøyd|Nøytral|Fornøyd|Veldig Fornøyd",
	"entry-notification-entry-details-header": "Oppføring detaljer",
	"FALSE": "USANT",
	"compare-greater-than-or-equal": "{property} må være større enn eller lik {compareSource}.",
	"receipt-notification-order-details-desc-header": "Beskrivelse",
	"order-method-label": "Metode",
	"order-total-label": "Bestill Total",
	"invalid-shared-link": "Ugyldig Delt Link",
	"fileupload-zero-byte-file-message": "Null byte filer kan ikke lastes opp.",
	"range-at-most": "{property} må være de fleste {max}.",
	"format-integer": "####",
	"order-date-label": "Dato",
	"fileupload-dropzone-message": "eller dra filer her.",
	"shared-entry-view-link": "Se den delte oppføring.",
	"format-currency": "kr # ###,##",
	"string-length-at-most": "{property} må være på de fleste {max} tegn.",
	"entry-confirmation-footer-tagline": "Opprette din egen kraftige betalingsformer med",
	"submit-button-text": "Sende",
	"marketing-msg": "Enkelt å lage kraftfulle former.",
	"required-if-on-or-after": "{property} er nødvendig når {compareSource} er på eller etter {compareValue}.",
	"card-on-file-agreement": "Jeg godtar å lagre kortet mitt for fremtidige transaksjoner.",
	"signature-draw": "tegne",
	"address-zip-code": "Zip Code",
	"compare-on-or-after": "{property} må være på eller etter {compareSource}.",
	"required-if-less-than-or-equal": "{property} er nødvendig når {compareSource} er mindre enn eller lik {compareValue}.",
	"field-datepicker-next-year": "Neste år",
	"change-button": "endre",
	"fileupload-desc-size-in-bytes-message": "{size} byte",
	"card-tab": "Kort",
	"order-billing-info-header": "Fakturering Info",
	"entry-email-view-details-text": "Vis hele oppføring på CognitoForms.com.",
	"save-and-resume-one-day-expiration-email-message": "Kopiere eller e-post linken nedenfor og gå tilbake til skjemaet i løpet av neste dag for å fullføre ditt bidrag.",
	"credit-card-authentication-failed": "Kredittkort mislyktes godkjenning.",
	"compare-less-than-or-equal": "{property} må være mindre enn eller lik {compareSource}.",
	"receipt-notification-order-details-balance-due": "Balanse På Grunn",
	"save-and-resume-multiple-days-expiration-message": "Kopiere eller e-post linken nedenfor og gå tilbake til skjemaet i løpet av de neste {days} dager å fullføre ditt bidrag.",
	"processing-fee-calculating-message": "Beregne",
	"receipt-notification-trx-details-method": "Metode",
	"field-choice-no-match": "Ingen samsvarende data",
	"fileupload-invalid-file-type-message": "Bare {allowedTypes} filer kan lastes opp.",
	"receipt-notification-trx-details-date": "Dato",
	"credit-card-authorization": "Korttillatelse",
	"address-line1": "Adresselinje 1",
	"required-if-not-exists": "{property} er nødvendig når {compareSource} ikke er spesifisert.",
	"required-if-not-equal": "{property} er nødvendig når {compareSource} er ikke {compareValue}.",
	"marketing-button-2": "Bygg Din Egen Gratis",
	"receipt-notification-billing-info-header": "Fakturering Info",
	"required-if-after": "{property} er nødvendig når {compareSource} er etter {compareValue}.",
	"element-label-name": "Navn",
	"required-if-equal": "{property} er nødvendig når {compareSource} er {compareValue}.",
	"connected-to-paypal": "Koblet til PayPal.",
	"people-form-email-quantity-exceeded-message": "E-postadressen må være unik.",
	"receipt-notification-order-details-subtotal": "Delsum",
	"shared-entry-edit-link": "Redigere delte oppføring.",
	"receipt-notification-trx-details-header": "Transaksjonsdetaljer",
	"address-city": "Poststed",
	"receipt-notification-order-details-amount-paid": "Beløpet betalt",
	"credit-card-invalid": "Kortet er ugyldig.",
	"format-decimal": "####,##",
	"entry-notification-new-submission-text": "Du har en ny skjemainnsending.",
	"this-and-that": "{0} og {1}",
	"field-ratingscale-good-poor-label": "Bra/Dårlig",
	"network-unavailable-message": "Nettverket er ikke tilgjengelig. Prøv igjen senere.",
	"dialog-close": "Lukk",
	"string-format-alphanumeric": "{property} må bare inneholde bokstaver og tall.",
	"credit-card": "Kredittkort",
	"remove-item": "Fjerne {item}",
	"receipt-notification-order-details-price-header": "Pris",
	"fileupload-upload-inprogress-message": "Filopplasting pågår.",
	"public-terms-of-service-link-text": "Vilkår for bruk",
	"save-and-resume-email-subject": "Lagre \u0026 Fortsett Link",
	"field-repeatingsection-remove-link-text": "Fjerne",
	"field-ratingscale-na-label": "N/A",
	"add-item": "Legg {item} til {item}",
	"field-toggle-options": "Ja/nei|Sann/Usann|Åpen/Lukket|Aktiv/Inaktiv|Lest/Ulest",
	"order-submit-timeout": "Ordrebehandling tar for lang. Prøv bestillingen senere.",
	"listlength-at-most": "Vennligst oppgi ikke mer enn {max} {property}.",
	"shared-entry-email-view-message": "Bruk linken nedenfor for å vise delte oppføring.",
	"order-number-label": "Nummer",
	"card-declined": "Kort avvist",
	"fileupload-default-upload-button-text": "Laste opp",
	"name-prefix": "Tittel",
	"address-line2": "Adresselinje 2",
	"element-label-email": "E-post",
	"field-ratingscale-good-poor-options": "Veldig Dårlig|Dårlig|Gjennomsnittlig|Bra|Veldig Bra",
	"next-button-text": "Neste",
	"question": "Spørsmålet",
	"address-postalcode": "Postnummer / Zip Code",
	"format-with-description": "{property} må formateres som {description}.",
	"field-datepicker-prev-month": "Forrige måned",
	"name": "Navn",
	"receipt-notification-order-details-total-footer": "Totalt",
	"confirmation-message": "Takk for at du fylle ut skjemaet. Svaret ditt er registrert.",
	"shared-entry-email-edit-message": "Bruk linken nedenfor for å redigere den delte oppføring.",
	"field-default-label": "Uten navn",
	"required-value": "{property} må være {value}.",
	"name-middle": "Mellomnavn",
	"fileupload-failed-upload-message": "{fileName} kunne ikke lastes opp.",
	"shared-entry-email-button-label": "Vis oppføring",
	"field-datepicker-year": "",
	"element-label-phone": "Telefon",
	"TRUE": "SANT",
	"listlength-between": "Vennligst oppgi mellom {min} og {max} {property}.",
	"marketing-button-1": "Prøv Det Nå",
	"entry-submission-error-heading": "Feil ved behandling oppføring",
	"order-not-found-message": "Fant ingen ordreinformasjon.",
	"format-without-description": "{property} er ikke riktig formatert.",
	"name-last": "Etternavn",
	"field-ratingscale-one-five-label": "Skala fra 1 til 5",
	"listlength-at-least": "Angi minst {min} {property}.",
	"united-states": "USA",
	"field-signature-captured": "Fanget",
	"compare-on-or-before": "{property} må være på eller før {compareSource}.",
	"order-balance-due-label": "Balanse På Grunn",
	"required-if-less-than": "{property} er nødvendig når {compareSource} er mindre enn {compareValue}.",
	"credit-card-postalcode": "Postnummer",
	"form-not-available-message": "Dette skjemaet er ikke tilgjengelig for øyeblikket.",
	"element-label-address": "Adresse",
	"receipt-notification-trx-details-number": "Nummer",
	"public-submission-warning": "Vennligst ikke Send passord gjennom Cognito Forms.",
	"save-and-resume-no-expiration-email-message": "Kopiere eller e-post linken nedenfor og gå tilbake til skjemaet for å fullføre ditt bidrag.",
	"fileupload-excluded-file-type-message": "Filer av denne typen kan ikke lastes opp.",
	"payment-subtotal": "Delsum",
	"collapse": "Skjule",
	"save-button-text": "Lagre",
	"field-datepicker-prev-year": "Forrige år",
	"signature-type": "skrive inn",
	"order-amount-minimum": "Beløps må være minst kr 1,00.",
	"string-format-numeric": "{property} kan bare inneholde tall.",
	"entry-confirmation-entry-details-header": "Oppføring detaljer",
	"connected-to-venmo": "Koblet til Venmo.",
	"format-percentage": "#,## %",
	"receipt-notification-header": "Kvittering",
	"clear": "Klart",
	"today": "I dag",
	"required-name-last": "Etternavn er nødvendig.",
	"marketing-button-3": "Prøv Det Nå",
	"expand": "Utvide",
	"compare-greater-than": "{property} må være større enn {compareSource}.",
	"field-ratingscale-will-wont-label": "Vil/Vil Ikke",
	"required-name-first": "Fornavn er nødvendig.",
	"save-and-resume-one-day-expiration-message": "Kopiere eller e-post linken nedenfor og gå tilbake til skjemaet i løpet av neste dag for å fullføre ditt bidrag.",
	"required-asterisk": "nødvendig",
	"credit-card-required": "Kredittkort er nødvendig.",
	"address-state-province-region": "Stat / Provins / Region",
	"save-and-resume-email-sent-message": "E-posten er sendt.",
	"workflow-action": "Handling",
	"field-ratingscale-will-wont-options": "Definitivt Ikke Vil|Sannsynligvis Ikke Vil|Usikker|Sannsynligvis Vil|Definitivt Vil",
	"save-and-resume-email-label": "Send meg min link:",
	"field-ratingscale-agree-disagree-options": "Helt Uenig|Uenig|Neutral|Enig|Helt Enig",
	"order-exception-order-already-paid": "Denne ordren er allerede betalt.",
	"fileupload-download-text": "Last ned",
	"address-state": "Stat",
	"allowed-values": "{property} er ikke i listen over tillatte verdier.",
	"shared-entry-workflow-email-button-label": "Åpne skjema",
	"compare-equal": "{property} må være det samme som {compareSource}.",
	"field-datepicker-clear": "Tøm",
	"name-first": "Fornavn",
	"save-and-resume-message": "Ditt skjema er lagret.",
	"save-and-resume-no-expiration-message": "Kopiere eller e-post linken nedenfor og gå tilbake til skjemaet for å fullføre ditt bidrag.",
	"entry-notification-view-details-text": "Vis Detaljer",
	"order-exception-default-message": "Kan ikke behandle transaksjonen.",
	"public-report-abuse-link-text": "Rapporter misbruk",
	"order-amount-paid": "Beløpet betalt",
	"element-label-default": "Uten navn",
	"countries": "Afghanistan|Albania|Algerie|Amerikansk Samoa|Andorra|Angola|Anguilla|Antarktis|Antigua og Barbuda|Argentina|Armenia|Aruba|Aserbajdsjan|Australia|Bahamas|Bahrain|Bangladesh|Barbados|Belgia|Belize|Benin|Bermuda|Bhutan|Bolivia|Bosnia-Hercegovina|Botswana|Brasil|Brunei Darussalam|Bulgaria|Burkina Faso|Burma, Burma|Burundi|Canada|Caymanøyene|Chile|Christmasøya|Cocos-(Keeling) øyene|Colombia|Cookøyene|Costa Rica|Cuba|Danmark|De forente arabiske emirater|De nederlandske Antillene|Demokratiske republikken Kongo (Kinshasa)|Den hellige stol|Den sentralafrikanske republikk|Djibouti|Dominica|Dominikanske republikk|Ecuador|Egypt|Ekvatorial-Guinea|El Salvador|Elfenbeinskysten|Eritrea|Estland|Etiopia|Falklandsøyene|Fiji|Filippinene|Finland|Frankrike|Fransk Guyana|Fransk Polynesia|Franske sørterritorier|Færøyene|Gabon|Gambia|Georgia|Ghana|Gibraltar|Grenada|Grønland|Guadeloupe|Guam|Guatemala|Guinea|Guinea-Bissau|Guyana|Haiti|Hellas|Honduras|Hong Kong|Hviterussland|India|Indonesia|Irak|Iran (islamske republikken)|Island|Israel|Italia|Jamaica|Japan|Jemen|Jomfruøyene (Storbritannia)|Jomfruøyene (USA)|Jordan|Kambodsja|Kamerun|Kapp Verde|Kasakhstan|Kenya|Kina|Kirgisistan|Kiribati|Komorene|Kongo, Republikken of(Brazzaville)|Korea, demokratiske \u0027 s rep (Nord-Korea)|Korea, Republic of (Sør-Korea)|Kosovo|Kroatia|Kuwait|Kypros|Lao, folk \u0027 s demokratiske republikk|Latvia|Lesotho|Libanon|Liberia|Libya|Liechtenstein|Litauen|Luxembourg|Macau|Madagaskar|Republikken Nord-Makedonia|Malawi|Malaysia|Maldivene|Mali|Malta|Man|Marokko|Marshalløyene|Martinique|Mauritania|Mauritius|Mayotte|Mexico|Mikronesia, føderale stater|Moldova, republikk av|Monaco|Mongolia|Montenegro|Montserrat|Mosambik|Namibia|Nauru|Nederland|Nepal|New Zealand|Nicaragua|Niger|Nigeria|Niue|Nord-Marianene|Norge|Ny-Caledonia|Oman|Pakistan|Palau|Palestinske territoriene|Panama|Papua Ny-Guinea|Paraguay|Peru|Pitcairnøyene|Polen|Portugal|Puerto Rico|Qatar|Réunion|Romania|Russiske føderasjon|Rwanda|Saint Kitts og Nevis|Saint Lucia|Saint Vincent og Grenadinene|Salomonøyene|Samoa|San Marino|Sao Tome \u0026amp; Principe|Saudi-Arabia|Senegal|Serbia|Seychellene|Sierra Leone|Singapore|Slovakia (Slovakia)|Slovenia|Somalia|Spania|Sri Lanka|Storbritannia|Sudan|Surinam|Sveits|Sverige|Swaziland|Syria, Syria|Sør-Afrika|Sør-Sudan|Tadsjikistan|Taiwan (Folkerepublikken Kina)|Tanzania; offisielt the United Republic of Tanzania|Thailand|Tibet|Togo|Tokelau|Tonga|Trinidad og Tobago|Tsjad|Tsjekkia|Tunisia|Turkmenistan|Turks-og Caicosøyene|Tuvalu|Tyrkia|Tyskland|Uganda|Ukraina|Ungarn|Uruguay|USA|Usbekistan|Vanuatu|Vatikanstaten (den hellige stol)|Venezuela|Vest-Sahara|Vietnam|Wallis-og Futunaøyene|Zambia|Zimbabwe|Østerrike|Øst-Timor (Øst-Timor)",
	"name-middleinitial": "MI",
	"order-exception-empty-order": "Rekkefølgen må inneholde minst ett linjeelement.",
	"compare-not-equal": "{property} må være forskjellig fra {compareSource}.",
	"entry-notification-footer": "Du mottar denne e-posten fordi du valgte alternativet motta e-postvarsler på skjemaet i Cognito Forms.",
	"save-and-resume-copy-link-label": "Kopier linken til skjemaet:",
	"entry-confirmation-footer": "Du mottar denne e-posten fordi du har fullført en transaksjon med [Name].",
	"required-if-on-or-before": "{property} er nødvendig når {compareSource} er på eller før {compareValue}.",
	"string-format": "{property} må formateres som {formatDescription}."
};
